import Button from '../../../components/form-control/Button';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { reviewRNPLApplication } from '../../../api/requests'; 
import { getSelectOptionsFromEnum, showToast } from '../../../utils/miscFunctions';
import { useState } from 'react';
import {  RNPL_REVIEW_STATES } from '../../../resources/enums';
import SelectDropdown from '../../../components/form-control/SelectDropdown';

interface EditLeadProps {
  onProceed: () => void;
  onClose: () => void;
  rnplApplicant: any;  
}

const EditLead = ({ onProceed, onClose, rnplApplicant }: EditLeadProps) => {
  const [loading, setLoading] = useState<boolean>(false);


  return (
    <div className="">

      <Formik
        initialValues={{ 
          reviewStage: String(rnplApplicant.reviewStage)
        }}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({ 
        })}
        onSubmit={(values) => {
          const payload: string =  values.reviewStage
          

          const id = rnplApplicant.id;
          if (id) setLoading(true);
          
           
          reviewRNPLApplication(id, payload)
            .then((response: any) => {
              onProceed();
              showToast.success(response.message && 'Review stage updated successfully.');
            })
            .catch((error: any) => {
              console.log(error);
            })
            .finally(() => { setLoading(false);});
           
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="p-8">
              <div className=" "> 
                  <div
                     >
                    <SelectDropdown
                      name="reviewStage"
                      listSelectedValue={values.reviewStage}
                      onChange={(value: string) => {
                        setFieldValue('reviewStage', value);
                      }}
                      label="Review Stage"
                      placeholder="Select review stage"
                      list={getSelectOptionsFromEnum(RNPL_REVIEW_STATES)}
                      required
                      error={touched.reviewStage ? errors.reviewStage : undefined}
                      helperText={touched?.reviewStage ? errors.reviewStage : undefined}
                      selectInputClassName="rounded"
                    />{' '}
                  </div>
                
              </div>

               <div className="w-full flex gap-4 mt-4">
                <Button
                type="button"
                label="Cancel"
                onClick={onClose}
                bgColor='secondary'
                  fullWidth
                
                />
                <Button
                label="Save"
                  onClick={handleSubmit}
                bgColor='primary'
              fullWidth
                disabled={loading}
                loading={loading}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default EditLead;
